import { useEffect, useState } from "react";

const getDimensions = () => {
  const { innerHeight: height, innerWidth: width } = window;
  
  return {
    height,
    width
  }
};

export const useDimensions = () => {
  const [dimensions, setDimensions] = useState(getDimensions());

  useEffect(() => {
    const updateDimensions = () => {
      setDimensions(getDimensions());
    };

    window.addEventListener('resize', updateDimensions);

    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return dimensions;
};